// Class to pass data between the tree views and the filter overview box
export class TreeViewFilterDataItem {
  controlName?: string;
  id?: string;
  text?: string;
  index?: string;
}

// Messages passed between criteria container and criteria controls
export type QueryPanelCriteriaMessageType = "add" | "delete" | "clear" | "filter" | "load" | "isLoaded";
export class QueryPanelCriteriaMessage {
  filter?: string;
  isFromTreeView?: boolean;
  item?: TreeViewFilterDataItem;
  type?: QueryPanelCriteriaMessageType;
  control?: string;
}
export type QueryPanelContentMessageType = "search" | "export" | "clear" ;
export class QueryPanelContentMessage {
  filter?: string;
  type?: QueryPanelContentMessageType;
  title?: string;
  criteria?: any;
  headerLines?: string[];
}

export class QueryPanelSummaryItem {
  controlName?: string;
  id?: string;
  text?: string;
  index?: string;
  cssclass?: string;
}

